// 导入ali-oss
import OSS from 'ali-oss';

/**
 * 配置信息
 */
const region = "oss-cn-beijing"; // 换成自己的region
const accessKeyId = "LTAI5tRaPbiAYhJ3YkP978N9"; // 换成自己的accessKeyId
const accessKeySecret = "I7IS1bJrTnZhSn1KKJPDpcXgXwB4bf"; // 换成自己的accessKeySecret
const bucket = "yjdd-static-resource"; // 换成自己的bucket  tstatics  7dd-statics   本地调试用tstatics，测试和正式都需要用 7dd-statics
// http://oss-cn-beijing.aliyuncs.com/refund/
let client = new OSS({
  region: region,
  accessKeyId: accessKeyId,
  accessKeySecret: accessKeySecret,
  bucket: bucket
});

/**
 *
 * @param {上传是设置文件key , 一般为文件名称} objectKey
 * @param {文件file} file
 */

//  上传
const CooOss = function (objectKey, file) {

  if (this instanceof CooOss) {

    return new Promise((resolve, reject) => {
      client.multipartUpload(objectKey, file).then(result => {
        resolve({
          code: 0,
          objectKey: objectKey,
          url: this.getOssFileUrl(objectKey),
          msg: "ok"
        });
      }).catch(err => {
        console.log(err);
        reject({
          code: -1,
          url: "",
          objectKey: "",
          msg: "上传出错了"
        });
      });
    })
  } else {
    return new CooOss(objectKey, file);
  }
};

/**
 *
 * @param {上传是设置文件key 一般是文件名} obecjtKey
 */
CooOss.prototype.getOssFileUrl = obecjtKey => {
  if (!obecjtKey) return new Error("object key 必须传");
  return "https://" + 'resources' + "." + "yijiudingdong.com/" + obecjtKey;
}
export default {
  install(Vue) {
    Vue.prototype.Oss = {
      uploadFile: CooOss,
    };
  }
};
